import apiClient from "./axios";
import { ApiResponse, PaginatedResponse, Transaction } from "../types";

export interface GetTransactionsParams {
  search?: string;
  source?: "payments" | "shop" | "business";
  status?: string;
  type?: string;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  minAmount?: number;
  maxAmount?: number;
  page?: number;
  limit?: number;
}

export interface TransactionDetail extends Transaction {
  user?: {
    id: string;
    phoneNumber: string | null;
    email?: string | null;
    firstName: string | null;
    lastName: string | null;
  } | null;
  metadata: Record<string, unknown> | null;
  providerReference: string | null;
  failureReason: string | null;
  providerResponse: Record<string, unknown> | null;
}

export const transactionsApi = {
  getTransactions: async (params: GetTransactionsParams = {}) => {
    const { data } = await apiClient.get<
      ApiResponse<PaginatedResponse<Transaction>>
    >("/admin/transactions", { params });
    return data.data;
  },

  getTransactionById: async (id: string) => {
    const { data } = await apiClient.get<ApiResponse<TransactionDetail>>(
      `/admin/transactions/${id}`,
    );
    return data.data;
  },
};
